export default {
  RETIREMENT_FUND_LOCATION_REPOSITORY: Symbol.for('RETIREMENT_FUND_LOCATION_REPOSITORY'),
  GET_RETIREMENT_FUND_LOCATION_QUERY: Symbol.for('GET_RETIREMENT_FUND_LOCATION_QUERY'),
  RETIREMENT_FUND_LOCATION_STATE_MANAGER: Symbol.for('RETIREMENT_FUND_LOCATION_STATE_MANAGER'),
};
